const AUTH_TIMEOUT = 4000;
const AUTH_RESEND_ATTENTION_CLASS = 'auth__attention';
const MIN_PASSWORD_LENGTH = 6;

export default class AuthPass {
  constructor() {
    this.wrapper = $(document).find('[data-entity="cheeks-auth-pass"]');
    this.completeSemaphore = true;
    this.phoneField = null;
    this.passwordField = null;
    this.passwordGroup = null;
    this.codeField = null;
    this.codeGroup = null;
    this.applyButton = null;
    this.finalAction = null;
    this.formError = null;
    this.resendBlock = null;
    this.form = null;
    this.wasEntered = false;
    this.timer = 60;
    this.resendAttentionInterval = null;
    this.timerInstance = null;
    this.decCache = [];
    this.canSendCode = true;
    this.autoAuthCallback = null;
    this.phoneInformer = null;
    this.faultCallback = function (data) {
      if (data.status === 500) {
        this.showError('Ошибка на стороне сервера. Попробуйте позже.')
      } else {
        this.showError('Ошибка. Попробуйте позже.')
      }
    }.bind(this);
    this.init();

  }

  init() {
    if (!this.wrapper.length) {
      return;
    }
    let self = this;
    let _self = this;

    this.phoneField = this.wrapper.find('[data-entity="cheeks-auth-login"]');
    this.passwordGroup = this.wrapper.find('[data-entity="cheeks-auth-password-group"]');
    this.passwordField = this.wrapper.find('[data-entity="cheeks-auth-password-field"]');
    this.codeGroup = this.wrapper.find('[data-entity="cheeks-auth-code-group"]');
    this.codeField = this.wrapper.find('[data-entity="cheeks-auth-code-field"]');
    this.applyButton = this.wrapper.find('[data-entity="cheeks-auth-apply"]');
    this.formError = this.wrapper.find('[data-entity="cheeks-auth-error-block"]');
    this.resendBlock = this.wrapper.find('[data-entity="cheec-auth-resend-block"]');
    this.form = this.wrapper.find('[data-entity="form"]');
    this.applyButton.on('click', this.onApplyClick.bind(this));
    this.phoneInformer = this.wrapper.find('[data-entity="phone-informer"]');


    this.resendBlock.on('click',this.onResendClick.bind(this));


    if (window.localStorage.getItem('auth-pass-login')
      && window.localStorage.getItem('auth-pass-login').match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}$/)) {
      this.phoneField.val(window.localStorage.getItem('auth-pass-login'));
      this.passwordField.attr('placeholder', 'Пароль есть у Вас в СМС от z2s.ru');
      this.showResendBlock();

      if (!_self.wasEntered && _self.resendBlock.hasClass('auth__pointer')) {
        _self.wasEntered = true;
        _self.bindResendAtteniton();
      }

      this.passwordField.bind('input', function (e) {
        if ($(this).val().length === 6
          && !(_self.passwordGroup.hasClass('has-success')
            || _self.passwordGroup.hasClass('has-error'))) {
          _self.passwordField.focusout();
        }
      });
    }

    this.finalAction = function () {
      dataLayer.push({
        'event': 'successful_authorization'
      });
      if (this.form.data('redirect')){
        window.location.href = this.form.data('redirect');
      }else if(window.chec.backUrl !== undefined){
        window.location.href = window.chec.backUrl;
      }else{
        window.location.href = '/personal/';
      }
    };
    this.form.on('submit', function (e) {
      e.preventDefault();
    });
    this.passwordField.on('keydown', function (e) {
      if (e.which === 13 && (_self.passwordField.val().length === 6 || !_self.applyButton.attr('disabled'))) {
        _self.onApplyClick(e);
      }
    });

    this.passwordField.on('keyup', function (e) {
      if ($(this).val().length === MIN_PASSWORD_LENGTH
        && _self.phoneField.val().match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}$/)) {
        _self.applyButton.attr('disabled', false);
      } else {
        _self.applyButton.attr('disabled', true);
      }
    });

    this.phoneField.on('keydown', function (e) {
      if (e.which === 13) {
        _self.phoneField.focusout();
      }
    });

    this.phoneField.inputmask({
      "mask": "+7 (!99) 999-9999",
      definitions: {
        '!': {
          validator: "[0-6,9]"
        }
      },
      'autoUnmask': false,
      "oncomplete": function (arg, arg2) {
        _self.onComplete();
        _self.passwordGroup.removeClass('hide');
        _self.applyButton.attr('disabled', false);
        if (_self.completeSemaphore){
          _self.bindResendAtteniton();
          _self.completeSemaphore = false;
        }
      },
      "onincomplete": function (arg, arg2) {
        if (!_self.passwordGroup.hasClass('hide')) {
          _self.removeSenderBlock();
        }
      },
      "oncleared": function () {
        if (!_self.passwordGroup.hasClass('hide')) {
          _self.removeSenderBlock();
        }
      }
    });


    $.validator.addMethod('phone', function (value, element) {
      if (value == '+7 (___) ___-____' || value == '') {
        return true;
      } else {
        return value.match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}$/);
      }
    }, 'Введите корректный телефон');


    this.form.validate({
      rules: {
        USER_PASSWORD: {
          required: true,
          minlength: MIN_PASSWORD_LENGTH,
          maxlength: MIN_PASSWORD_LENGTH,
        },
        USER_LOGIN: {
          phone: true,
          required: true,
        },
        TEST: {
          required: true,
          minlength: 4,
        },
      },
      messages: {
        USER_LOGIN: {
          required: "Это поле обязательно для заполнения",
          phone: "Введите корректный номер телефона",
        },
        USER_PASSWORD: {
          required: "Найдите пароль в смс или запросите новый",
          minlength: "Пароль должен быть не меньше 6 символов",
          maxlength: "Пароль должен быть не больше 6 символов"
        }
      },
      highlight: function (element, status, some, som2) {
      },
      unhighlight: function (element, status, some) {

      },
      errorPlacement: function (error, element, some) {
        let $elem = $(element);
        if ($elem.data('entity') === _self.phoneField.data('entity')) {
          if ($elem.val() === '') {
            $elem.parents('.form-group').removeClass('has-error');
            $elem.parents('.form-group').removeClass('has-success');
          } else {
            $elem.parents('.form-group').removeClass('has-success');
            $elem.parents('.form-group').addClass('has-error');
            $elem.parent('.form-group').find('.error-message').text($(error).text());
          }
        }

        if ($elem.data('entity') === _self.passwordField.data('entity')) {
          $elem.parents('.form-group').addClass('has-error');
          $elem.parents('.form-group').removeClass('has-success');
          setTimeout(function () {
            $elem.parent('.form-group').find('.error-message').text($(error).text());
          }, 200);
          _self.applyButton.attr('disabled', true);
        }
      },
      success: function (block, element) {
        let $elem = $(element);
        if ($elem.data('entity') === _self.passwordField.data('entity')) {
          $elem.parents('.form-group').removeClass('has-error');
          $elem.parents('.form-group').addClass('has-success');
          _self.applyButton.attr('disabled', false)
        }

        $elem.parents('.form-group').removeClass('has-error');
      },
      errorElement: 'div'
    });

  }

  onResendClick(){
    this.resendBlock.unbind();
  }

  //Когда введен номер телефона
  onComplete() {
    let _self = this;
    if (!this.canSendCode) {
      return;
    }
    $.ajax({
      url: '/ajax/authActions.php',
      dataType: 'json',
      data: {
        login: _self.phoneField.val(),
        action: 'isExist',
      },
      cache: false,
      success: function (data) {
        if (data.exist) {
         // _self.passwordField.attr('autocomplete','current-password');
          _self.phoneField.parents('.form-group').addClass('has-success');
          _self.removeError();
          _self.showResendBlock();
          _self.passwordField.attr('placeholder', 'Пароль есть у Вас в СМС от z2s.ru');
        } else {
          _self.openPopupForm()
          _self.sendAuthCode();
        }
        if (typeof _self.autoAuthCallback === 'function') {
          _self.autoAuthCallback();
        }
        _self.passwordField.focus();
      },
      error: function (data) {
        _self.faultCallback(data)
      }
    });
  }

  sendAuthCode() {
    this.resendBlock.unbind();
    let _self = this;
    $.ajax({
      url: '/ajax/authActions.php',
      dataType: 'json',
      data: {
        login: _self.phoneField.val(),
        action: 'sendCode',
        code: _self.codeField.val(),
      },
      cache: false,
      success: function (data) {

        if (data.sended) {
          _self.phoneField.parents('.form-group').addClass('has-success');
          _self.removeError();
          _self.passwordGroup.find('label').text('Введите код из СМС');
          _self.passwordGroup.removeClass('hide');
          _self.applyButton.attr('disabled', false);
          _self.showTimerBlock();
          _self.removeError();
          _self.passwordGroup.removeClass('hide');
          _self.passwordField.attr('placeholder', 'Пароль есть у Вас в СМС от z2s.ru');
          _self.passwordField.focus();
          return;
        } else if (data.userError) {
          _self.passwordGroup.addClass('hide');
          _self.showError(data.message);
          _self.removeSenderBlock();
          return;
        }
        _self.passwordGroup.removeClass('hide');
        _self.showError(data.message);
        _self.showTimerBlock();
      },
      error: function (data) {
        _self.faultCallback(data)
      }
    });
  }

  //TODO вызов final action
  bindFinalAction(callback) {
    if (typeof callback === 'function') {
      this.finalAction = callback;
    }
  }

  onApplyClick(e) {
    let _self = this;
    e.preventDefault();
    $.ajax({
      url: '/ajax/authActions.php',
      dataType: 'json',
      data: {
        login: _self.phoneField.val(),
        action: 'authorize',
        password: _self.passwordField.val(),
      },
      cache: false,
      success: function (data) {
        if (data.authorized) {
          window.localStorage.setItem('auth-pass-login', _self.phoneField.val());
          _self.removeError();
          if (typeof _self.finalAction === 'function') {
            _self.finalAction();
          }
        } else {
          _self.openPopupForm();
          if (_self.resendBlock.hasClass('auth__pointer')) {
            clearTimeout(_self.resendAttentionInterval);
            _self.resendBlock.addClass(AUTH_RESEND_ATTENTION_CLASS);
          }
          _self.applyButton.attr('disabled', true);
          _self.showError(data.message);
        }
      },
      error: function (data) {
        _self.faultCallback(data)
      }
    });

  }

  autoAuth(phoneValue) {
    window.localStorage.setItem('auth-pass-login', '');
    this.passwordField.attr('placeholder', 'Пароль есть у Вас в СМС от z2s.ru');
    this.bindResendAtteniton();
    this.wrapper.removeClass('login');
    this.phoneField.val(phoneValue);
    this.phoneField.focusout();
    this.phoneField.parent('.form-group').css('display', 'none');
    this.onComplete();
  }

  bindAutoAuth(callback) {
    if (typeof callback === 'function') {
      this.autoAuthCallback = callback;
    }
  }

  showError(message) {
    this.removeError();
    this.formError.find('[data-entity="cheeks-auth-error-message"]').text(message);
    this.formError.css('display', 'block');

  }
  removeError() {
    this.formError.css('display', 'none');
    this.formError.find('[data-entity="cheeks-auth-error-message"]').text('');
  }

  // Отображает кнопку с таймером
  showTimerBlock() {

    if (this.timer !== 0) {
      this.canSendCode = false;
      //снимаем прослушку с событием
      this.resendBlock.unbind();
      this.resendBlock.removeClass('auth__pointer');
      clearTimeout(this.timerInstance);
      this.timerInstance = setTimeout(() => {
        // this.decOfNum();
        this.timer -= 1;
        this.resendBlock.removeClass(AUTH_RESEND_ATTENTION_CLASS);
        this.resendBlock.text('Повторная отправка через ' + this.timer + ' с');
        if (this.resendBlock.css('display') !== 'block') {
          this.resendBlock.css('display', 'block');
          this.applyButton.attr('disabled', false);
        }
        this.showTimerBlock();

      }, 1000);

    } else {
      this.showResendBlock();
    }

  }

  //Отображает кнопку с переотправкой
  showResendBlock() {
    this.codeGroup.css('display', 'block');
    this.resendBlock.unbind();
    this.resendBlock.on('click', this.sendAuthCode.bind(this));
    this.completeSemaphore = true;
    this.resendBlock.css('display', 'block');
    this.resendBlock.addClass('auth__pointer');
    this.timer = 100;
    this.resendBlock.text('Отправить пароль в СМС');
    this.canSendCode = true;
  }

  removeSenderBlock() {
    this.codeGroup.css('display', 'none');
    this.resendBlock.css('display', 'none');
  }

  bindResendAtteniton() {
    let self = this;
    clearTimeout(this.resendAttentionInterval);
    this.resendAttentionInterval = setTimeout(function () {
      if (self.resendBlock.hasClass('auth__pointer') && !self.resendBlock.hasClass(AUTH_RESEND_ATTENTION_CLASS)) {
        self.resendBlock.addClass(AUTH_RESEND_ATTENTION_CLASS);
      }
    }, AUTH_TIMEOUT);
  }

  decOfNum() {
    let decCases = [2, 0, 1, 1, 1, 2];
    let titles = ['секунду', 'секунды', 'секунд'];
    if (!this.decCache[this.timer]) this.decCache[this.timer] = this.timer % 100 > 4 && this.timer % 100 < 20 ? 2 : decCases[Math.min(this.timer % 10, 5)];
    return titles[this.decCache[this.timer]];
  }

  bindFaultAction(callback) {
    if (typeof callback === 'function') {
      this.faultCallback = callback;
    }
  }

  checkAutoAuthBinded() {
    return (typeof this.autoAuthCallback === 'function');
  }

  openPopupForm(){
    if(!!window.amoFormId){
      $(document).find('#actionDetailModal').foundation('open')
      amo_forms_params.resizeForm("amoforms_iframe_" + window.amoFormId)
    }
  }

}
